import { render, staticRenderFns } from "./POFUTracker.vue?vue&type=template&id=2a3b4165&"
import script from "./POFUTracker.vue?vue&type=script&lang=js&"
export * from "./POFUTracker.vue?vue&type=script&lang=js&"
import style0 from "./POFUTracker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports